<!--
  Компонент ReferralBonusTooltip — тултип с подсказкой о бонусных днях за рефералов.
-->
<script setup lang="ts">
import { useReferralBonusList } from '@/composables/useReferralBonusList'
import { useI18n } from 'vue-i18n'

interface IProps {
  iconSize?: number
}

withDefaults(defineProps<IProps>(), {
  iconSize: 24,
})

const { referralBonusList } = useReferralBonusList()
const { t } = useI18n()
</script>

<template>
  <v-tooltip>
    <template #activator="{ props: activatorProps }">
      <v-icon
        icon="ri-information-line"
        v-bind="activatorProps"
        color="primary-light"
        :size="iconSize"
      />
    </template>
    <div class="d-flex flex-column ga-1">
      <span>{{ t('promo.bonusTooltip') }}</span>
      <span v-for="item in referralBonusList" :key="item.id">
        • {{ item.periodName }} — {{ item.referralBonusDays }} {{ t('common.daysShort') }}
      </span>
    </div>
  </v-tooltip>
</template>
